<template>
  <div class="showcase d-flex flex-column" id="main-card">
    <p class="configurator-label text-center mb-0" style="border-bottom: 1px solid #ccc;">
      <slot name="title" />
    </p>
    <div v-if="selected" class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-1">
      <slot name="selected-content" />
    </div>
    <div
      v-else
      class="flex-grow-1 d-flex flex-column justify-content-between p-3"
    >
      <div class="d-flex flex-column align-items-center justify-content-center mt-3 text-muted">
        <font-awesome-icon :icon="['far', 'info-circle']" size="xl" fixed-width />
        <p class="text-center flex-grow-1 align-self-center">{{ emptyTitle }}</p>
      </div>

      <Button
        variant="blue"
        :disabled="submitalLocked"
        @click="$emit('open-selectable')"
      >
        Seleccionar
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Button from '../../shared/Button'

export default {
  name: 'SelectableCard',
  components: { Button },
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    emptyTitle: {
      type: String,
      default: 'No se ha seleccionado aún'
    }
  },
  computed: {
    ...mapGetters(['submitalLocked'])
  }
}
</script>

<style scoped>
#main-card {
  width: 400px;
}

@media (max-width: 768px) {
  #main-card {
    width: 100%;
  }
}

</style>
